module.exports = __webpack_public_path__ + "img/help_dataset_svg2.184f4326.png";